// Angular
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
// rxjs
import { combineLatest, Observable } from 'rxjs';

// Misc
import { claimQuery } from '@amfam/claim/data-access';
import { PostFnolContext, PostFnolInitPayload } from '@amfam/claim/post-fnol/feature';
// Store
import { PolicySelectors } from '@amfam/policy/data-access';
import { userQuery } from '@amfam/shared/user';
import { routerQuery } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../../core/store/';

@Component({
  selector: 'ds-post-fnol-wrapper',
  templateUrl: './post-fnol-wrapper.component.html',
  styleUrls: [],
  standalone: false
})
export class PostFnolWrapperComponent implements OnInit {
  postFnolData: Observable<PostFnolInitPayload>;
  previousUrl: Observable<string>;

  constructor(private store: Store<fromRoot.RootState>) {}

  ngOnInit() {
    this.previousUrl = this.store.select(routerQuery.getRouterPreviousStateUrl);
    this.postFnolData = combineLatest(
      this.store.select(claimQuery.selectSelectedClaim),
      this.store.select(userQuery.selectCustomerId),
      this.store.select(userQuery.selectLoginName),
      this.store.select(userQuery.selectDisplayName),
      this.store.select(userQuery.selectEmailAddress),
      this.store.select(PolicySelectors.selectAutoPolicyRisks),
      (claim, customerId, userId, name, email, autoRisks) => {
        const vin = _get(claim, 'autoClaimDetails[0].vin');
        const selectedRisk = autoRisks.find(risk => risk.vin === vin);
        const garageZip = _get(selectedRisk, 'risk.garageLocationAddress.zipCode');
        const exposureId = _get(claim, 'exposureId', '');
        const policyNumber = _get(selectedRisk, 'policyNumber');
        return {
          context: PostFnolContext.MY_ACCOUNT,
          claimNumber: _get(claim, 'claimNumber'),
          policyNumber: policyNumber,
          customerId: customerId,
          userId: userId,
          name: name,
          exposureId: exposureId,
          vin: vin,
          emailAddress: email,
          garageZipcode: garageZip
        };
      }
    );
  }
}
